// extracted by mini-css-extract-plugin
export default {"columns":"style_columns__TNz19","threeColumns":"style_threeColumns__3OCkN","twoColumns":"style_twoColumns__b+7DP","oneColumn":"style_oneColumn__D-cIW"};